import { ArrowRight } from "lucide-react";
import PageHero from "../components/sections/PageHero";
import { ButtonLink } from "../components/ui/Button";
import { routes } from "../data/site";
import { localHref } from "../lib/links";

const destinations = [
  {
    label: "Results",
    text: "Real companies, real numbers.",
    href: routes.caseStudies,
  },
  {
    label: "Services",
    text: "What we build and how we work.",
    href: routes.services,
  },
  { label: "Blog", text: "Insights and company news.", href: routes.insights },
  { label: "Contact", text: "Talk to a real person.", href: routes.contact },
];

export default function NotFoundPage() {
  return (
    <>
      <PageHero
        eyebrow="Error 404 · Page not found"
        title="Wrong turn. Let's get you *back on site.*"
        lede="The page you're looking for has moved or doesn't exist anymore. Try one of these instead."
      >
        <div className="flex flex-wrap gap-3.5">
          <ButtonLink href={routes.home}>Back to home</ButtonLink>
          <ButtonLink variant="glass" />
        </div>
      </PageHero>
      <section className="bg-surface px-4 py-16 sm:px-6 md:py-20">
        <nav aria-label="Popular pages" className="mx-auto max-w-280">
          <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {destinations.map(({ label, text, href }) => (
              <li key={label} className="grid">
                <a
                  href={localHref(href)}
                  className="group rounded-b-brand border-t-4 border-yellow bg-white px-6 pt-6 pb-7 shadow-soft transition duration-200 hover:-translate-y-0.5 hover:shadow-lift motion-reduce:hover:translate-y-0"
                >
                  <span className="font-display flex items-center justify-between text-2xl text-slate uppercase group-hover:text-ink">
                    {label}
                    <ArrowRight
                      size={20}
                      className="text-blue-deep transition-transform group-hover:translate-x-1"
                      aria-hidden="true"
                    />
                  </span>
                  <span className="mt-1.5 block text-[15px] text-muted">
                    {text}
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </section>
    </>
  );
}
